//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  nuxtI18n: {
    paths: {
      br: '/base-de-conhecimento',
      en: '/knowledge-base',
      es: '/base-de-conocimientos'
    }
  },

  async asyncData({ $api }) {
    try {
      const { data } = await $api.knowledgeBase.showAll()
      const sectionsItems = data

      const sections = sectionsItems.map((section) => {
        return {
          label: section.title,
          url: `/base-de-conhecimento/${section.slug}`
        }
      })

      return { sections }
    } catch (err) {
      $api.instance.handleResponseError(err)
    }
  },

  data() {
    return {
      sections: []
    }
  },

  head() {
    return this.$helpers.seoBuilder(this, {
      staticTitle: this.$t('title')
    })
  },

  computed: {
    breadcrumbs() {
      const breadcrumbs = [
        {
          name: this.$t('home'),
          path: '/'
        },
        {
          name: this.$t('title'),
          path: '/base-de-conhecimento'
        }
      ]

      return breadcrumbs
    }
  }
}
